// 接入chatGPT 的
import Axios from "axios";
import util from '@/api/util'
const url = 'https://ai.topeti.com/api/light'
const keyU = 'username'
const valueU = 'a-gpt-3.5'
const keyP = 'password'
const valueP = '8975618'
// const url = document.domain === 'localhost' ? 'http://yuying-api.xutongbao.top/api/light' : 'https://ssl-yuying-api.xutongbao.top/api/light'
// 登陆
export const loginAi = () => {
    return Axios({
        url: url + "/user/appLogin",
        method: "post",
        data: {
            [keyU]: valueU,
            [keyP]: valueP
        }
    }).catch(err => { console.log(err) })
}

// 聊天查询
export const getAddAi = ({sendMessage, talkId}) => {
    const authorization = window.localStorage.getItem('authorization')
    return Axios({
        url: url + "/chat/add",
        method: "post",
        headers: {
          authorization: authorization
        },
        data: {
          talkId: talkId,
          message: sendMessage,
          isNeedContext: true
        }
    }).catch((err) => { console.log(err) })
}

// 查询登陆状态
export const getLogin = () => {
    const authorization = window.localStorage.getItem('authorization')
    return Axios({
        url: url + '/user/getInfo',
        method: 'post',
        headers: {
            authorization: authorization
        }
    }).catch(err => { console.log(err) })
}

// 新增会话
export const addTalk = (data) => {
    const authorization = window.localStorage.getItem('authorization')
    return Axios({
        url: url + '/talk/add',
        method: 'post',
        headers: {
            authorization: authorization
        },
        /**
         * name,userId 这两是data的
         * **/
        data: data
    }).catch(err => { console.log(err) })
}

// 接入文心一言的
const wxurl = util.apiUrl()
// 获取文心token
export const getRobotToken = token => {
  return Axios({
    url: wxurl + '/openapi/getbdtoken',
    // url: 'https://user.topeti.com/openapi/getbdtoken',
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    params: {
      accesstoken: token
      // accesstoken: '794a2248ca58a20daf6fa1920378b3ba26e1bd34a6dc8c9dcccd0dc7f2acf83f5f50f3c7723b62e19fcf888b5ec62b7fd521f6ce021e8704c15bce5fa3bf64d3'
    }
  })
}

// 与文心一言发起甜蜜的会话
export const talkToRobot = (token, msg) => {
  return Axios({
    url:
      'https://aip.baidubce.com/rpc/2.0/ai_custom/v1/wenxinworkshop/chat/completions',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    params: {
      access_token: token
    },
    data: {
      messages: msg
    }
  })
}